import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="1" y="12" width="2" height="4" rx="1"/><rect x="29" y="12" width="2" height="4" rx="1"/><circle cx="22" cy="20" r="1"/><circle cx="10" cy="20" r="1"/><path d="M24.08,2H7.92A3.93,3.93,0,0,0,4,5.92V24.15A1.85,1.85,0,0,0,5.85,26H7v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V26h6v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V26h1.15A1.85,1.85,0,0,0,28,24.15V5.92A3.93,3.93,0,0,0,24.08,2ZM11,28H9V26h2Zm12,0H21V26h2Zm3-4H6V16H26Zm0-10H6V8H26Zm0-8H6V5.92A1.92,1.92,0,0,1,7.92,4H24.08A1.92,1.92,0,0,1,26,5.92Z"/>';
export var BusOutlineSVG = function BusOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BusOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BusOutlineSVG);